<template>
  <div class="">
    <div class="pro1">
      <div class="pro1-1">
        <div class="l"><span>项目名称</span><i v-show="!edit">{{ project.name }}</i> <input v-show="edit" type="text"
            v-model="project.name"></div>
        <div class="r" @click="changeEdit"><img src="@/assets/images/edit.png" alt="">{{ edit ? '确定' : '编辑' }}</div>
      </div>
      <div class="pro1-2">
        简介：
        <span v-show="!edit">{{ project.info }}</span>
        <input v-show="edit" type="text" v-model="project.info">
      </div>
      <div class="pro1-3">
        <div class="item">
          <div class="it1">脚本</div>
          <div class="it2"><span>15</span>段</div>
        </div>
        <div class="item">
          <div class="it1">角色/场景</div>
          <div class="it2"><span>6</span>个</div>
        </div>
        <div class="item">
          <div class="it1">分镜画面</div>
          <div class="it2"><span>15</span>张</div>
        </div>
        <div class="item">
          <div class="it1">时间线</div>
          <div class="it2"><span></span>2分30秒</div>
        </div>
        <div class="item">
          <div class="it1">提案PPT</div>
          <div class="it2"><span>30</span>页</div>
        </div>
        <div class="item">
          <div class="it1">素材库</div>
          <div class="it2"><span>475</span>页</div>
        </div>
      </div>
      <div class="pro1-4">
        <div class="stepbox">
          <div class="step"></div>
        </div>
        <span>完成进度60%</span>
      </div>
    </div>
    <div class="pro2">
      <div class="pro2-top">
        <div class="l">最新动态</div>
        <!-- <div class="r">更多 ></div> -->
      </div>
      <div class="pro2-body" style="">
        <div class="item"><i>4月21日 09:08</i><i>郭飞</i>完成了<span>第一段脚本</span></div>
        <div class="item"><i>4月21日 09:08</i><i>郭飞</i>完成了<span>第一段脚本</span></div>
        <div class="item"><i>4月21日 09:08</i><i>郭飞</i>完成了<span>第一段脚本</span></div>
        <div class="item"><i>4月21日 09:08</i><i>郭飞</i>完成了<span>第一段脚本</span></div>
        <div class="item"><i>4月21日 09:08</i><i>郭飞</i>完成了<span>第一段脚本</span></div>
        <div class="item"><i>4月21日 09:08</i><i>郭飞</i>完成了<span>第一段脚本</span></div>
        <div class="item"><i>4月21日 09:08</i><i>郭飞</i>完成了<span>第一段脚本</span></div>
        <div class="item"><i>4月21日 09:08</i><i>郭飞</i>完成了<span>第一段脚本</span></div>
      </div>
    </div>
    <div class="line"></div>
    <div class="pro3">
      <div class="pro3-top">
        项目
      </div>
      <div class="pro3-body">
        <div class="item" @click="$router.push(`/project2/project2_1?id=${id}`)">
          <div class="it1">5积分/次</div>
          <div class="it2"><img src="@/assets/images/cy.png" alt=""></div>
          <div class="it3">创意构思</div>
          <div class="it4">脚本策划、情节设计、角色设定</div>
          <div class="it5">
            <div>ChatGPT</div>
            <div>ChatGPT</div>
            <div>ChatGPT</div>
          </div>
          <div class="it6">进入创作</div>

        </div>
        <div class="item">
          <div class="it1">10-20积分/次</div>
          <div class="it2"><img src="@/assets/images/fj.png" alt=""></div>
          <div class="it3">分镜设计</div>
          <div class="it4">场景设计、视觉风格、构图布局</div>
          <div class="it5">
            <div>ChatGPT</div>
            <div>ChatGPT</div>
            <div>ChatGPT</div>
          </div>
          <div class="it6">进入创作</div>

        </div>
        <div class="item">
          <div class="it1">40-60积分/次</div>
          <div class="it2"><img src="@/assets/images/sp.png" alt=""></div>
          <div class="it3">视频生成</div>
          <div class="it4">动态呈现、镜头切换、转场效果</div>
          <div class="it5">
            <div>ChatGPT</div>
            <div>ChatGPT</div>
            <div>ChatGPT</div>
          </div>
          <div class="it6">进入创作</div>

        </div>
        <div class="item">
          <div class="it1">15-30积分/次</div>
          <div class="it2"><img src="@/assets/images/yy.png" alt=""></div>
          <div class="it3">音频创作</div>
          <div class="it4">背景音乐、配音录制、音效设计</div>
          <div class="it5">
            <div>ChatGPT</div>
            <div>ChatGPT</div>
            <div>ChatGPT</div>
          </div>
          <div class="it6">进入创作</div>

        </div>
        <div class="item">
          <div class="it1">支持导出到Final Cut、PR</div>
          <div class="it2"><img src="@/assets/images/sjx.png" alt=""></div>
          <div class="it3">故事版时间线</div>
          <div class="it4">拖拽组织你的视频、音频素材，创建完整故事线。支持基础剪辑、转场、字幕添加。</div>
          <div class="it5">
            <div>拖拽排序</div>
            <div>基础剪辑</div>
            <div>转场效果</div>
            <div>字幕同步</div>
          </div>
          <div class="it6">进入创作</div>

        </div>
      </div>
    </div>
    <div class="pro4">
      <div class="pro4-top">
        团队优秀作品
      </div>
      <div class="pro4-body">
        <div class="item">
          <div class="it1"><img src="@/assets/images/test2.png" alt=""></div>
          <div class="it2">春节团圆故事</div>
          <div class="it3">以传统与现代结合的视角以传统与现代结合的视以传统与现代结合的视.</div>
          <div class="it4">
            <div class="l">李导演 · 2小时前</div>
            <div class="r"><img src="@/assets/images/like.png" alt="">12</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  data () {
    return {
      id: 0,
      edit: false,
      project: {}
    }
  },
  async created () {
    this.$bus.$emit('menu-active', true) // 关闭激活状态
    this.id = this.$route.query.id
    const res = await this.$http('api.getProject', { id: this.id })
    this.project = res.data
  },
  methods: {
    async changeEdit () {
      if (this.edit) {
        // 确认
        this.edit = false
        const res = await this.$http('api.upPeoject', this.project)
        this.$message.success('修改成功')
      } else {
        // 编辑
        this.edit = true
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.pro1,
.pro2,
.pro3,
.pro4 {
  margin: 0 auto;
  margin-top: 20px;
  width: 1240px;
}

.pro1 {
  padding: 20px;
  height: 328px;
  border-radius: 16px 16px 16px 16px;
  border: 1px solid #DDDDDD;

  .pro1-1 {
    display: flex;
    justify-content: space-between;

    .l {
      font-size: 24px;
      color: #262626;

      input {
        border: none;
        border-bottom: 1px solid #d3d2d2;
        font-size: 16px;
        width: 300px;
      }

      span {
        display: inline-block;
        padding: 2px 6px;
        font-size: 16px;
        color: #A76134;
        background-color: #FED9AD;
        border-radius: 6px;
        margin-right: 16px;
        transform: translateY(-2px);
      }

      i {
        font-style: normal;
      }
    }

    .r {
      font-size: 16px;
      color: #046DFA;
      cursor: pointer;

      img {
        width: 24px;
        margin-right: 4px;
        transform: translateY(-2px);
      }
    }
  }

  .pro1-2 {
    margin-top: 10px;
    width: 1200px;
    height: 50px;
    line-height: 50px;
    padding-left: 20px;
    background: #F8F8F8;
    border-radius: 4px 4px 4px 4px;

    input {
      border: none;
      border-bottom: 1px solid #d3d2d2;
      font-size: 16px;
      width: 90%;
      height: 100%;
      background-color: transparent;
    }
  }

  .pro1-3 {
    display: flex;
    height: 130px;
    margin-top: 20px;

    .item {
      width: 130px;
      height: 100%;
      overflow: hidden;
      color: #A76134;
      margin-right: 20px;
      background: linear-gradient(135deg, #FEF5EA, #FED9AD);

      .it1 {
        font-size: 16px;
        width: 100%;
        text-align: center;
        margin-top: 20px;
      }

      .it2 {
        text-align: center;
        margin-top: 10px;
        font-size: 20px;

        span {
          margin-right: 4px;
          font-size: 32px;
        }
      }
    }

    .item:nth-child(2n) {
      color: #0053BF;
      background: linear-gradient(135deg, #EDF5FF, #BCD8FD);
    }

    .item:nth-child(3n) {
      color: #059669;
      background: linear-gradient(135deg, #EDFDF2, #BDF7D1);
    }

    .item:nth-child(4n) {
      color: #8C3AED;
      background: linear-gradient(135deg, #FCF3FF, #E9D6FF);
    }
  }

  .pro1-4 {
    margin-top: 22px;
    display: flex;
    justify-content: space-between;

    .stepbox {
      margin-top: 6px;
      width: 90%;
      height: 10px;
      background: #F8F8F8;
      border-radius: 12px 12px 12px 12px;

      .step {
        width: 50%;
        height: 10px;
        background: #FED9AE;
        border-radius: 12px 12px 12px 12px;
      }
    }

    span {
      font-size: 16px;
      color: #262626;

    }
  }
}

.pro2 {

  height: 270px;
  border-radius: 8px 8px 8px 8px;
  border: 1px solid #DDDDDD;
  padding: 20px;

  .pro2-top {
    display: flex;
    justify-content: space-between;

    .l {
      font-size: 18px;
      color: #262626;
    }

    .r {
      font-size: 16px;
      color: #595959;
      cursor: pointer;
    }
  }

  .pro2-body {
    margin-top: 6px;
    height: 200px;
    overflow: auto;

    .item {
      position: relative;
      height: 30px;
      font-size: 16px;
      padding-left: 30px;

      i {
        font-style: normal;
        margin-right: 4px;
      }

      span {
        margin-left: 4px;
        color: #046DFA;
      }
    }

    .item::after {
      position: absolute;
      display: block;
      content: '';
      border-radius: 50%;
      top: 9px;
      left: 6px;
      width: 8px;
      height: 8px;
      background-color: rgb(51, 122, 228);
    }

    .item:before {
      position: absolute;
      display: block;
      content: '';
      top: 9px;
      left: 10px;
      width: 0px;
      height: 30px;
      border-left: 1px dotted rgb(51, 122, 228);
    }

    .item:last-child::before {
      display: none;
    }
  }
}

.line {
  margin-top: 20px;
  width: 100%;
  height: 0;
  border-top: 1px solid #DDDDDD;
}

.pro3 {
  padding: 20px 0;

  .pro3-top {
    font-size: 18px;
    color: #262626;
  }

  .pro3-body {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    .item {
      padding: 16px;
      margin-top: 20px;
      width: 284px;
      height: 360px;
      background: linear-gradient(135deg, #FEF5EA 0%, #FED9AD 100%);
      border-radius: 12px 12px 12px 12px;
      border: 1px solid #FED7AA;
      color: #A76134;
      position: relative;

      .it1 {
        font-size: 14px;
        text-align: right;
      }

      .it2 {
        margin-top: 20px;
        width: 32px;

        img {
          width: 100%;
        }
      }

      .it3 {
        margin-top: 12px;
        font-size: 18px;

      }

      .it4 {
        font-size: 16px;
        margin-top: 20px;
      }

      .it5 {
        margin-top: 16px;
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;

        div {
          margin-right: 10px;
          background: #FFFFFF;
          border-radius: 30px 30px 30px 30px;
          font-size: 12px;
          padding: 4px 8px;
          margin-bottom: 6px;
        }
      }

      .it6 {
        position: absolute;
        width: 84px;
        text-align: center;
        height: 30px;
        line-height: 30px;
        background: #FFFFFF;
        border-radius: 30px 30px 30px 30px;
        bottom: 30px;
        left: 16px;
        font-size: 12px;
      }
    }

    .item:nth-child(2n) {
      background: linear-gradient(136deg, #EDF5FF 0%, #BCD8FD 100%);
      border: 1px solid #BAD7FD;
      color: #0053BF;
    }

    .item:nth-child(3n) {
      background: linear-gradient(135deg, #EDFDF2 0%, #BDF7D1 100%);
      border: 1px solid #BBF7D0;
      color: #059669;
    }

    .item:nth-child(4n) {
      background: linear-gradient(134deg, #FCF3FF 0%, #E9D6FF 100%);
      border: 1px solid #E9D5FF;
      color: #8C3AED;
    }

    .item:nth-child(5n) {
      background: linear-gradient(134deg, #FCF3FF 0%, #E9D6FF 100%);
      border: 1px solid #E9D5FF;
      color: #8C3AED;
    }
  }
}

.pro4 {
  margin-top: 20px;

  .pro4-top {
    font-size: 18px;
    color: #262626;
  }

  .pro4-body {
    padding-bottom: 20px;
    display: flex;
    flex-wrap: wrap;
    .item {
      margin-top: 20px;
      margin-right: 30px;
      width: 280px;
      height: 260px;
      background: #FFFFFF;
      border-radius: 12px 12px 12px 12px;
      border: 1px solid rgba(221, 221, 221, 0.87);
      padding: 16px;
      position: relative;

      .it1 {
        width: 100%;
        height: 120px;
        overflow: hidden;

        img {
          width: 100%;
        }
      }

      .it2 {
        margin-top: 12px;
        font-size: 16px;
        color: #262626;
      }

      .it3 {
        margin-top: 8px;
        font-size: 14px;
        color: #595959;
        width: 100%;
        white-space: nowrap;
        /* 强制文本不换行 */
        overflow: hidden;
        /* 隐藏超出容器的内容 */
        text-overflow: ellipsis;
        /* 超出部分显示省略号 */
      }

      .it4 {
        display: flex;
        justify-content: space-between;
        position: absolute;
        bottom: 16px;
        padding: 0 20px;
        left: 0;
        width: 100%;
        height: 20px;
        line-height: 20px;
        font-size: 14px;
        color: #595959;

        .l {}

        .r {
          img {
            width: 16px;
            margin-right: 4px;
          }
        }
      }
    }
  }
}
</style>
